<Tailwindcss />
<svelte:head>
  {#if mounted}
    <script type="text/javascript">
      var __ss_noform = __ss_noform || [];
      __ss_noform.push([
        "baseURI",
        "https://app-3QNM3YRW7Y.marketingautomation.services/webforms/receivePostback/MzawMLEwNDIxBAA/"
      ]);
      __ss_noform.push([
        "form",
        "zoekprofile-form",
        "a75f34dc-e38e-4cd8-b70a-89f7587c9004"
      ]);
      __ss_noform.push(["submitType", "manual"]);
    </script>
    <script
      type="text/javascript"
      src="https://koi-3QNM3YRW7Y.marketingautomation.services/client/noform.js?ver=1.24">

    </script>
  {/if}
</svelte:head>

<form
  id="zoekprofile-form"
  on:submit|preventDefault={handleSubmit}
  style={`padding-bottom: ${bottomBarHeight > 150 ? bottomBarHeight + 100 : 250}px`}>
  <div class="header">
    <div class="title">
      <span>Zoekprofiel</span>
    </div>
    <div class="tabs" class:complete={currentTab > 5}>
      {#each tabs as tab, i}
        <div class:active={currentTab === i}>
          {#if tab.complete}
            <CheckFilled />
          {:else}
            <Check />
          {/if}
          {#if currentTab === i}
            <span>{tab.title}</span>
          {/if}
        </div>
      {/each}
    </div>
  </div>

  {#if currentTab < tabs.length}
    <span class="name">{tabs[currentTab].title}</span>
  {/if}

  <Stepper
    {components}
    bind:step={currentTab}
    on:complete={({ detail }) => (tabs[currentTab].complete = !!detail)} />
  <div class="bottom" bind:clientHeight={bottomBarHeight}>
    {#if currentTab < tabs.length}
      {#if currentTab < tabs.length - 1}
        <button
          class="next"
          disabled={!tabs[currentTab].complete}
          on:click={() => {
            currentTab++;
            window.jQuery('#zoekprofiel').animate({ scrollTop: 0 });
          }}
          type="button">
          Volgende
        </button>
      {:else}
        <button
          class="next"
          disabled={!tabs[currentTab].complete}
          type="submit">
          Volgende
        </button>
      {/if}
      {#if currentTab > 0}
        <button class="prev" on:click={() => currentTab--} type="button">
          Vorige
        </button>
      {/if}
    {:else}
      <button
        class="next"
        type="button"
        on:click={() => {
          window.closeModalZoek();
        }}>
        Woningaanbod
      </button>
    {/if}
  </div>
</form>

<script>
  import Tailwindcss from "./Tailwindcss.svelte";
  import Stepper from "./Stepper.svelte";
  import Check from "./Check.svelte";
  import CheckFilled from "./CheckFilled.svelte";
  import PersonalInfo from "./PersonalInfo.svelte";
  import PurchasePurpose from "./PurchasePurpose.svelte";
  import HouseType from "./HouseType.svelte";
  import Budget from "./Budget.svelte";
  import Bedroom from "./Bedroom.svelte";
  import Bathroom from "./Bathroom.svelte";
  import Complete from "./Complete.svelte";

  import { onMount } from "svelte";
  let mounted = false;
  onMount(function() {
    mounted = true;
  });

  if (!window.zoekModalOptions) window.zoekModalOptions = {};

  let bottomBarHeight;
  $: console.log(bottomBarHeight);

  let tabs = [
    {
      complete: false,
      title: "Doel aankoop"
    },
    {
      complete: false,
      title: "Type woning"
    },
    {
      complete: false,
      title: "Budget"
    },
    {
      complete: false,
      title: "Slaapkamer"
    },
    {
      complete: false,
      title: "Badkamer"
    },
    {
      complete: false,
      title: "Persoonlijke gegevens"
    }
  ];
  const components = [
    PurchasePurpose,
    HouseType,
    Budget,
    Bedroom,
    Bathroom,
    PersonalInfo,
    Complete
  ];
  let currentTab = 0;

  function handleSubmit(args) {
    console.log("SUBMIT");
    window.__ss_noform.push([
      "submit",
      null,
      "a75f34dc-e38e-4cd8-b70a-89f7587c9004"
    ]);
    setTimeout(() => {
      window.location.href = "/bedankt-zoekprofiel";
    }, 500);
  }
</script>

<style lang="postcss">
  .title {
    font-weight: 500;
    @apply w-full px-5 py-6;
  }

  .title span {
    @apply text-2xl;
  }

  .tabs {
    font-weight: 500;
    @apply flex;
  }

  .tabs div {
    @apply relative w-full p-4 flex justify-center items-center min-w-0 border;
  }

  .tabs span {
    @apply hidden ml-4 truncate;
  }

  .tabs div ~ div {
    @apply border-l-0;
  }

  .tabs div.active::after {
    content: "";
    @apply absolute left-0 bottom-0 w-full h-1 bg-primary;
  }

  .tabs :global(svg) {
    @apply flex-shrink-0;
  }

  .name {
    @apply block w-full mt-8 mb-2 text-center;
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: white;
    @apply mt-16 py-8 px-16 border-t;
  }

  .bottom button {
    @apply w-full py-4;
  }

  .bottom .next {
    background: #202020;
    @apply text-white;
  }

  .bottom .prev {
    @apply border border-black;
  }

  .bottom button:disabled {
    background: #c1c3ca;
    @apply cursor-default;
  }

  .bottom button ~ button {
    @apply mt-5;
  }

  @screen sm {
    .title {
      @apply w-full px-12 py-4;
    }

    .title span {
      @apply text-lg;
    }

    .name {
      @apply hidden;
    }

    .tabs div {
      @apply w-auto px-8 py-6;
    }

    .tabs.complete div,
    .tabs div.active {
      @apply w-full;
    }

    .tabs span {
      @apply inline-block;
    }

    .bottom {
      @apply flex flex-row-reverse justify-start;
    }

    .bottom button {
      @apply w-40;
    }

    .bottom button ~ button {
      @apply mr-5 mt-0;
    }
  }

  @screen md {
    .header {
      @apply flex items-center border-b;
    }

    .title {
      @apply w-auto pl-32;
    }

    .title span {
      @apply text-xl;
    }

    .tabs > div {
      @apply border-t-0 border-b-0;
    }

    .tabs {
      @apply w-auto;
    }

    .bottom {
      @apply px-32;
    }

    .bottom button ~ button {
      @apply mr-32;
    }
  }
</style>
